import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isOrganizerLoading = (state: TRootState): boolean =>
  arrayContains(state.organizer.openRequests, [
    Actions.findOrganizerRequest.type,
    Actions.findOrganizersRequest.type,
    Actions.searchOrganizersRequest.type,
    Actions.createOrganizerRequest.type,
    Actions.updateOrganizerRequest.type,
    Actions.deleteOrganizerRequest.type,
  ]);
